var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProductCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1157_59465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 20.6667C17.1046 20.6667 18 19.7713 18 18.6667C18 17.5622 17.1046 16.6667 16 16.6667C14.8954 16.6667 14 17.5622 14 18.6667C14 19.7713 14.8954 20.6667 16 20.6667Z",
    fill: "#C2C4C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3332 9.33333H21.3332V7.33333C21.3332 6.44928 20.982 5.60143 20.3569 4.97631C19.7317 4.35119 18.8839 4 17.9998 4H13.9998C13.1158 4 12.2679 4.35119 11.6428 4.97631C11.0177 5.60143 10.6665 6.44928 10.6665 7.33333V9.33333H6.6665C5.60564 9.33333 4.58822 9.75476 3.83808 10.5049C3.08793 11.2551 2.6665 12.2725 2.6665 13.3333V24C2.6665 25.0609 3.08793 26.0783 3.83808 26.8284C4.58822 27.5786 5.60564 28 6.6665 28H25.3332C26.394 28 27.4115 27.5786 28.1616 26.8284C28.9117 26.0783 29.3332 25.0609 29.3332 24V13.3333C29.3332 12.2725 28.9117 11.2551 28.1616 10.5049C27.4115 9.75476 26.394 9.33333 25.3332 9.33333ZM13.3332 7.33333C13.3332 7.15652 13.4034 6.98695 13.5284 6.86193C13.6535 6.7369 13.823 6.66667 13.9998 6.66667H17.9998C18.1766 6.66667 18.3462 6.7369 18.4712 6.86193C18.5963 6.98695 18.6665 7.15652 18.6665 7.33333V9.33333H13.3332V7.33333ZM15.9998 23.3333C15.0769 23.3333 14.1746 23.0596 13.4072 22.5469C12.6397 22.0341 12.0416 21.3052 11.6884 20.4525C11.3352 19.5998 11.2428 18.6615 11.4228 17.7562C11.6029 16.851 12.0474 16.0195 12.7 15.3668C13.3527 14.7142 14.1842 14.2697 15.0894 14.0897C15.9947 13.9096 16.933 14.002 17.7857 14.3552C18.6384 14.7084 19.3673 15.3066 19.88 16.074C20.3928 16.8414 20.6665 17.7437 20.6665 18.6667C20.6665 19.9043 20.1748 21.0913 19.2997 21.9665C18.4245 22.8417 17.2375 23.3333 15.9998 23.3333Z",
    fill: "#C2C4C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1157_59465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductCamera);
export default __webpack_public_path__ + "static/media/icon_product_camera.b19149a9c085e686363b645a6e0f9c61.svg";
export { ForwardRef as ReactComponent };